document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('wishlist-grid')) {
        displayWishlist();
    }

    refreshAllWishlistButtons();
});

document.addEventListener('cart-drawer:open', function () {
    refreshAllWishlistButtons();
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wishlist_button').forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            toggleWishlist(button);
        });
    });
});

/**
 * Retrieves the wishlist from localStorage
 * @returns {Array} Wishlist array
 */
function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
}

/**
 * Saves the wishlist to localStorage
 * @param {Array} wishlistData Wishlist array to save
 */
function saveWishlist(wishlistData) {
    localStorage.setItem('wishlist', JSON.stringify(wishlistData));
}

/**
 * Toggles a product in the wishlist
 */
function toggleWishlist(button) {
    const pdpData = {
        id: generateUUID(),
        di: generateUUID().slice(0, 8), // short UUID
        handle: button.dataset.handle,
        vo: button.dataset.variantOption,
        epi: button.dataset.variantId,
        empi: button.dataset.productId,
        dt: button.dataset.title,
        iu: button.dataset.img,
        pr: button.dataset.price,
        currency: button.dataset.currency,
        du: button.dataset.url,
        sku: button.dataset.sku,
        vi: button.dataset.variantTitle,
        pid: btoa(button.dataset.productId + '-' + button.dataset.variantId),
        cts: Date.now(),
        uts: Date.now()
    };

    let wishlistData = getWishlist();
    const wishlistText = button.querySelector('.wishlist_text');

    const isAlreadyInWishlist = wishlistData.some(item =>
        item.epi === pdpData.epi
    );

    if (isAlreadyInWishlist) {
        // Remove
        wishlistData = wishlistData.filter(item => item.epi !== pdpData.epi);
        button.classList.remove('wishlist-added');
        if (wishlistText) wishlistText.textContent = "Save To Wishlist";
    } else {
        // Add
        wishlistData.push(pdpData);
        button.classList.add('wishlist-added');
        if (wishlistText) wishlistText.textContent = "Saved To Wishlist";
    }

    saveWishlist(wishlistData);
    updateWishlistCount();
    refreshAllWishlistButtons();
}

/**
 * Removes a product from the wishlist
 * @param {string} variantId Variant ID to remove
 */
function removeFromWishlist(variantId) {
    let wishlistData = getWishlist();
    wishlistData = wishlistData.filter(item => item.epi !== variantId);
    saveWishlist(wishlistData);
    displayWishlist();
    updateWishlistCount();
}

/**
 * Displays the wishlist on the page
 */
function displayWishlist() {
    const wishlistData = getWishlist();
    const wishlistGrid = document.getElementById('wishlist-grid');
    const emptyWishlistBlock = document.querySelector('.emptyWishlist');

    if (!wishlistGrid || !emptyWishlistBlock) {
        console.error('Required element not found');
        return;
    }

    if (wishlistData.length === 0) {
        wishlistGrid.innerHTML = '';
        emptyWishlistBlock.style.display = 'flex';
        return;
    }

    emptyWishlistBlock.style.display = 'none';
    wishlistGrid.innerHTML = '';

    wishlistData.forEach(item => {
        if (!item.handle || !item.vo) {
            console.warn('Skipping item without handle or vo:', item);
            return;
        }

        const cleanHandle = item.handle.split('?')[0];
        const url = `/products/${cleanHandle}?variant=${item.epi}&view=wishlist-card`;

        fetch(url)
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text();
            })
            .then(html => {
                const li = document.createElement('li');
                li.className = 'grid__item';

                const range = document.createRange();
                console.log(html,'html')
                const nodes = range.createContextualFragment(html);
                li.appendChild(nodes);
     console.log(nodes,'nodes')
                // Add remove button
                const removeButton = document.createElement('button');
                removeButton.className = 'remove-wishlist';
                removeButton.textContent = 'x';
                removeButton.addEventListener('click', () => {
                    removeFromWishlist(item.epi);
                });

                li.appendChild(removeButton);
                wishlistGrid.appendChild(li);

                requestAnimationFrame(() => {
                    adjustImageContainers?.();
                    bindProductCardEvents?.(li);
                    bindSizeButtons?.(li);
                });
            })
            .catch(error => {
                console.error(`Error loading product "${item.handle}" with variant "${item.vo}":`, error);
            });
    });
}

/**
 * Updates the wishlist button state on PDP
 * @param {HTMLElement} button Wishlist button element
 * @param {Array} wishlistData Wishlist data array
 * @param {string} variantId Variant ID to check
 */
function updateWishlistButton(button, wishlistData, variantId) {
    const wishlistText = button.querySelector('.wishlist_text');
    const isAlreadyInWishlist = wishlistData.some(item => item.epi === variantId);

    if (isAlreadyInWishlist) {
        button.classList.add('wishlist-added');
        if (wishlistText) {
            wishlistText.textContent = "Saved To Wishlist";
        }
    } else {
        button.classList.remove('wishlist-added');
        if (wishlistText) {
            wishlistText.textContent = "Save To Wishlist";
        }
    }
}

/**
 * Updates all wishlist buttons on the page
 */
function refreshAllWishlistButtons() {
    const wishlistData = getWishlist();

    // console.log(wishlistData)

    const wishlistButtons = document.querySelectorAll('.wishlist_button');
    wishlistButtons.forEach(button => {
        const variantId = button.dataset.variantId;
        updateWishlistButton(button, wishlistData, variantId);
    });
}

/**
 * Optional: Updates Wishlist count badge (e.g. in header)
 */
function updateWishlistCount() {
    const count = getWishlist().length;
    const badge = document.querySelector('.wishlist-count-badge');
    if (badge) {
        badge.textContent = count > 0 ? count : '';
    }
}

/**
 * Generates a simple UUID
 */
function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

const wishlistObserver = new MutationObserver((mutationsList, observer) => {
    observer.disconnect();
    refreshAllWishlistButtons();
    setTimeout(() => {
        observer.observe(document.body, {childList: true, subtree: true});
    }, 200);
});

wishlistObserver.observe(document.body, {
    childList: true,
    subtree: true
});



function bindSizeButtons(container = document) {
    container.querySelectorAll('.button-popup-option').forEach(button => {
        if (!button.dataset.bound) {
            button.dataset.bound = 'true';

            button.addEventListener('click', function () {
                const variantId = this.dataset.variantId;
                const label = this.dataset.variantLabel;
                selectVariant(this, variantId, label);
            });
        }
    });
}

function selectVariant(button, variantId, variantLabel) {
    console.log('Set variant ID:', variantId);

    const wrapper = button.closest('.product_variants_wrapper');
    if (!wrapper) return;

    const labelSpan = wrapper.querySelector('modal-opener span[data-selected-label]');
    if (labelSpan) {
        labelSpan.textContent = variantLabel;
    }

    const form = wrapper.querySelector('product-form');
    if (!form) return;

    const input = form.querySelector('input[name="id"]');
    if (input) input.value = variantId;

    const submitButton = form.querySelector('button[name="add"]');
    if (submitButton) {
        submitButton.id = `${variantId}-submit`;
        submitButton.setAttribute('aria-labelledby', `${variantId}`);
    }

    const modal = wrapper.querySelector(`modal-dialog`);
    if (modal) modal.removeAttribute('open');
}
